import React from 'react';
import { LinearProgress } from '@totalsoft/rocket-ui';
import { Box } from '@mui/material';

function WrappedLinearProgress({ ...wrapperProps }) {
  return (
    <Box sx={{ width: '100%', ...wrapperProps }}>
      <LinearProgress color='primary' sx={{ '&.MuiLinearProgress-root': { mb: 0, borderRadius: '100vw' } }} />
    </Box>
  );
}

export default WrappedLinearProgress;
